<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid class="home-content rounded-lg">
      <v-tabs v-model="tabIndex">
        <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
      </v-tabs>
    </v-container>
    <v-container fluid class="home-content rounded-lg">
      <v-row  justify="center">
        <v-tabs-items v-model="tabIndex" class="min-width">
          <v-tab-item active class="">
           <post-config></post-config>
          </v-tab-item>
<!--            <v-tab-item active class="">-->
<!--           <sidebar-post></sidebar-post>-->
<!--          </v-tab-item>-->
        </v-tabs-items>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import PostConfig from "@/views/Pages/config/configNew/new_post_config";

// import SidebarPost from "@/views/Pages/config/sidebar_new_post";

export default {
  components: {
    PostConfig,
    // SidebarPost
   
  },
  data() {
    return {
      tabIndex: 0,
      items: [
        {id: 0, tab: "Danh mục tin tức"},
        // {id: 1, tab: "Menu phải trang tin tức"},
        
      ],
      page: "Trang tin tức",
      breadcrumbs: [
        {
          text: "Trang tin tức",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
    ]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style lang="scss">
.home-content {
  background: #ffffff !important;
}
.min-width {
  min-width: 90% !important;
}
</style>
